export const DEFAULT_SITE_MARGIN_PRESET = 'STANDARD';

export const SITE_MARGIN_PRESETS = Object.freeze([
    {value: 'TIGHT', label: 'Tight', margin: 24, gridGap: 24},
    {value: 'COMPACT', label: 'Compact', margin: 64, gridGap: 24},
    {value: 'STANDARD', label: 'Standard', margin: 126, gridGap: 48},
    {value: 'WIDE', label: 'Wide', margin: 196, gridGap: 24},
    {value: 'EXTRA_WIDE', label: 'Extra wide', margin: 284, gridGap: 24},
]);

export function getSiteMarginPreset(value) {
    return SITE_MARGIN_PRESETS.find(preset => preset.value === value)
        || SITE_MARGIN_PRESETS.find(preset => preset.value === DEFAULT_SITE_MARGIN_PRESET);
}
